import React, { Component, Fragment } from 'react';
import { Layout, Typography, Button, Row, Col, Card, Table, MonitorOutlined, DatePicker, Form, Space, Input, Switch } from 'antd';
import { SearchOutlined, EditOutlined, LoadingOutlined, SaveOutlined, CloseCircleOutlined } from '@ant-design/icons'
import AdminPortalHeader from '../../components/common/admin_portal_header';
import { getPolicyByIdForAdmin, SavePolicyDocumentSentStatusByIdForAdmin, SavePetTagSentStatusByIdForAdmin, GetPolicyAndClaimHealthInfo, SavePreExistingConditions, SaveRenewalBlockedStatus, GetRenewalBlockedStatus } from '../../api/pets-api';
import { PolicyStatus } from '../../api/constants';
import { notifications, getToken, fixPhoneNumber } from "../../helpers/utilities";
import moment from 'moment';


const { Paragraph, Title } = Typography;
const { Content } = Layout;
const { TextArea } = Input;


class AdminPolicyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            policyId:'',
            policySerial:'',
            policy:{},
            policyStatus: '',
            policyHealth:{},
            editPreExistingCondition:false,
            editPreExistingConditionLoader:false,
            renewalBlockedLoader: false,
            renewalBlockedStatus: null, // Add this to track the renewal status
        };
        this.policyDocFormRef = React.createRef();
        this.petTagFormRef = React.createRef();
        this.setPreExistingConditionFormRef = React.createRef();
    }

    async componentDidMount() {
        
    }

    async componentWillMount(){
        var splittedPath = this.props.location.pathname.split('/');
        console.log(splittedPath[splittedPath.length - 1]);
        let id = splittedPath[splittedPath.length - 1];
        await this.getPolicy(id);
    }

    async getPolicy(id){
        try{
            let respo = await getPolicyByIdForAdmin(id);
            console.log('Policy API Response:', respo); // Debug log
            let policy = {};
            if(respo.status == 200){
                policy = respo.data.result[0];
                
                // Debug: Log the policy object to verify field names
                console.log('Policy object fields:', Object.keys(policy));
                console.log('Policy ID field:', policy.id);
                console.log('Policy renewal blocked status:', policy.renewalBlocked);
                
                var stringPolicyCode = '0000000000' + policy.policySerial;
                var delimitedSerial = stringPolicyCode.substring(stringPolicyCode.length - 7);
                policy.policySerialNumber = 'OSLO-'+policy.policyCurrency.toUpperCase()+'-'+policy.policyType+'-'+delimitedSerial
                
                let benefits = policy.benefits == 5000 ? 20000 : policy.benefits == 10000 ? 35000 : 70000
                
                policy.benefits = benefits;

                let status = policy.status == PolicyStatus.submitted ? "Just Purchased" : policy.status == PolicyStatus.policy_doc_sent ? "Policy Document Sent" : policy.status == PolicyStatus.pet_tag_sent ? "Pet Tag Sent" : "";

                let isContinuesRenewal = policy.isRenewal && policy.isContinues;

                var dateOfBirth = moment(policy.dob);
                var dateOfPurchase = moment(policy.effectiveDate);

                let policyActBasedDate = dateOfPurchase;
                let dateCopy = dateOfPurchase;

                var diff = dateOfPurchase.diff(dateOfBirth, 'months');
                if(diff < 2){
                    policyActBasedDate = (dateOfBirth.add(2, 'M'));
                    dateCopy = (dateOfBirth.add(2, 'M'));
                }

                let activationDate = dateCopy.toDate();
                if(!isContinuesRenewal){
                    activationDate.setDate(policyActBasedDate.toDate().getDate() + 6);  
                }
                
                let illnessCoverDate = dateCopy.toDate();
                if(!isContinuesRenewal){
                    illnessCoverDate.setDate(policyActBasedDate.toDate().getDate() + 14);
                }

                let kneeCoverDate = dateCopy.toDate();
                if(!isContinuesRenewal){
                    kneeCoverDate.setMonth(policyActBasedDate.toDate().getMonth() + 6);
                }

                policy.accidentCoverDate = activationDate;
                policy.illnessCoverDate = illnessCoverDate;
                policy.kneeCoverDate = kneeCoverDate;

                let policyHealth = await GetPolicyAndClaimHealthInfo(id);

                this.setState({policy:policy, policySerial:policy.policySerialNumber, policyStatus:status, policyHealth:policyHealth.data.result});
                
                console.log('Final policy object:', policy);

                // Fetch renewal blocked status after policy is loaded
                await this.fetchRenewalBlockedStatus(policy.id);
            }else{
                this.setState({policy:{}});
            }
        }catch(ex){
            console.error('Error getting policy:', ex);
            this.setState({policy:{}});
        }
    }

    // Add method to fetch renewal blocked status
    fetchRenewalBlockedStatus = async (petId) => {
        try {
            console.log('Fetching renewal blocked status for pet:', petId);
            const response = await GetRenewalBlockedStatus(petId);
            
            if (response.status === 200 && response.data.status === 'ok') {
                const renewalData = response.data.data;
                console.log('Renewal blocked status response:', renewalData);
                
                this.setState({
                    renewalBlockedStatus: renewalData.renewalBlocked,
                    policy: {
                        ...this.state.policy,
                        renewalBlocked: renewalData.renewalBlocked
                    }
                });
            } else {
                console.warn('Failed to fetch renewal blocked status:', response);
                // Set default to false if API fails
                this.setState({
                    renewalBlockedStatus: false,
                    policy: {
                        ...this.state.policy,
                        renewalBlocked: false
                    }
                });
            }
        } catch (error) {
            console.error('Error fetching renewal blocked status:', error);
            // Set default to false if API fails
            this.setState({
                renewalBlockedStatus: false,
                policy: {
                    ...this.state.policy,
                    renewalBlocked: false
                }
            });
        }
    }

    savePolicyDocSentDate = async (values) => {
        let data = {
            id:this.state.policy.policyId,
            status:PolicyStatus.policy_doc_sent,
            date:moment(values.documentSentDate).format('YYYY/MM/DD')
        }
        let res = await SavePolicyDocumentSentStatusByIdForAdmin(data);
        if(res.data.result){
            window.location.reload();
        }
    }

    savePetTagSentDate = async (values) => {
        let data = {
            id:this.state.policy.policyId,
            status:PolicyStatus.pet_tag_sent,
            date:moment(values.documentSentDate).format('YYYY/MM/DD')
        }
        let res = await SavePetTagSentStatusByIdForAdmin(data);
        if(res.data.result){
            window.location.reload();
        }
    }

    enablePreExistingCondition = () => {
        this.setState({editPreExistingCondition:true})
    }

    updatePreExistingCondition = async (values) => {
        this.setState({editPreExistingConditionLoader:true});
        let data = {
            id:this.state.policy.id,
            preExistingCondition:values.preExistingCondition
        }
        console.log(data);
        let res = await SavePreExistingConditions(data);
        if(res.status == 200){
            notifications('Pre Existing Conditions Updated.', 'Alert', 'success');
            this.setState({editPreExistingConditionLoader:false, editPreExistingCondition:false, policy:{...this.state.policy, preExistingCondition:values.preExistingCondition}});
        }else{
            notifications('Error Occured. Please try again.', 'Alert', 'error');
            this.setState({editPreExistingConditionLoader:false});
        }
    }

    disablePreExistingCondition = () => {
        this.setState({editPreExistingCondition:false})
    }

    // Update the method to handle renewal blocked status toggle
    handleRenewalBlockedToggle = async (checked) => {
        this.setState({ renewalBlockedLoader: true });
        
        try {
            const data = {
                petId: this.state.policy.id,
                renewalBlocked: checked
            };
            
            console.log('Sending renewal blocked data:', data);
            
            const res = await SaveRenewalBlockedStatus(data);
            
            if (res.status === 200) {
                // Check if response has success indicators
                const isSuccess = res.data?.success !== false;
                
                if (isSuccess) {
                    this.setState({
                        renewalBlockedLoader: false,
                        renewalBlockedStatus: checked,
                        policy: {
                            ...this.state.policy,
                            renewalBlocked: checked
                        }
                    });
                    
                    notifications(
                        `Renewal ${checked ? 'blocked' : 'unblocked'} successfully.`,
                        'Alert',
                        'success'
                    );
                } else {
                    throw new Error(res.data?.message || 'API returned failure status');
                }
            } else {
                throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            }
            
        } catch (error) {
            console.error('Error updating renewal status:', error);
            this.setState({ renewalBlockedLoader: false });
            
            // More detailed error message
            const errorMessage = error.response?.data?.message || 
                               error.message || 
                               'Error updating renewal status. Please try again.';
            
            notifications(errorMessage, 'Alert', 'error');
        }
    }

    render() {
        return (
            <Layout className="dashboard claims">
                <AdminPortalHeader />
                <div className="m-2">
                    <Title level={2} className="text-green font-600 pt-3 ps-3 m-0">Policies</Title>
                    <Title level={3} className="text-green font-600 pt-1 ps-3 m-0">{this.state.policySerial}</Title>
                    <Title level={4} className="text-red font-600 pt-1 ps-3 m-0">{this.state.policyStatus}</Title>
                </div>
                <div className="m-2">
                    <Row gutter={15}>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card title="Policy & Pet Details" className='full-width p-2'>
                            <Title level={5} className="text-green font-600 pt-1 m-0">Pet</Title>
                            <hr/>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Name</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policy.name}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Pet Type</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policy.type}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Breed</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policy.breed}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Date of Birth</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{moment(this.state.policy.dob).format('MMM/YYYY')}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Gender</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policy.gender}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Microchip No</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policy.microchip}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Tag</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policy.tag}</span>
                                </Col>
                            </Row>
                            
                            {/* New Renewal Blocked Toggle */}
                            {this.state.renewalBlockedStatus !== null && (
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Block Renewals</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <Space align='center'>
                                            <Switch
                                                checked={this.state.policy.renewalBlocked || false}
                                                onChange={this.handleRenewalBlockedToggle}
                                                loading={this.state.renewalBlockedLoader}
                                                checkedChildren="Blocked"
                                                unCheckedChildren="Allowed"
                                            />
                                            <span className={this.state.policy.renewalBlocked ? 'text-red' : 'text-green'}>
                                                {this.state.policy.renewalBlocked ? 'Renewals Blocked' : 'Renewals Allowed'}
                                            </span>
                                        </Space>
                                    </Col>
                                </Row>
                            )}

                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Pre Existing Conditions</span>
                                </Col>
                                {(!this.state.editPreExistingCondition) && <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <Space align='center'>
                                        <span>{this.state.policy.preExistingCondition}</span>
                                        <Button type="primary" shape="circle" size='small' icon={<EditOutlined />} onClick={() => this.enablePreExistingCondition()} />
                                    </Space>
                                </Col>}
                                {(this.state.editPreExistingCondition) && <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <Form
                                        name="basic"
                                        className="customise-form"
                                        ref={this.setPreExistingConditionFormRef}
                                        onFinish={this.updatePreExistingCondition}
                                        initialValues={{preExistingCondition:this.state.policy.preExistingCondition}}
                                    >
                                        <Space align='end'>
                                            <Form.Item
                                                className='mb-0'
                                                name="preExistingCondition"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '*Please add pre existing conditions',
                                                    },
                                                ]}
                                            >
                                                <TextArea rows={4}>
                                                </TextArea>
                                            </Form.Item>
                                            {this.state.editPreExistingConditionLoader && <LoadingOutlined className='text-green' />} 
                                            <Form.Item className='mb-0'>
                                                {!this.state.editPreExistingConditionLoader && <Button type="primary" htmlType='submit' shape="circle" size='small' icon={<SaveOutlined />}/>}
                                            </Form.Item>
                                            <Form.Item className='mb-0'>
                                            {!this.state.editPreExistingConditionLoader && <Button type="danger" shape="circle" size='small' icon={<CloseCircleOutlined onClick={() => this.disablePreExistingCondition()} />} /> }
                                            </Form.Item>
                                        </Space>
                                    </Form>
                                </Col>}
                            </Row>
                            <Title level={5} className="text-green font-600 pt-1 mt-2">Policy</Title>
                            <hr/>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Plan</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policy.planTitle}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Benefits</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>AED {this.state.policy.benefits}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Co-Payment</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policy.copayment} %</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Deductible</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>AED {this.state.policy.deductable}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Policy Eff. Date</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{moment(this.state.policy.effectiveDate).format('YYYY/MMM/DD')}</span>
                                </Col>
                            </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Accident Cov. Start</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{moment(this.state.policy.accidentCoverDate).format('YYYY/MMM/DD')}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Illness Cov. Start</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{moment(this.state.policy.illnessCoverDate).format('YYYY/MMM/DD')}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Knee Cov. Start</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{moment(this.state.policy.kneeCoverDate).format('YYYY/MMM/DD')}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Policy Value</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>AED {this.state.policy.policyValue}</span>
                                </Col>
                            </Row>
                                <Title level={5} className="text-green font-600 pt-1 mt-2">Claims</Title>
                            <hr/>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Lost Ratio</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{ parseFloat(this.state.policyHealth.lostRatio).toFixed(0) }%</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Number Of Claims Submitted</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policyHealth.totalCount}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Total Of Claims Submitted</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>AED {parseFloat(this.state.policyHealth.totalAmount).toFixed(2)}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Number Of Claims Paid</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>{this.state.policyHealth.acceptedCount}</span>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <span className='text-green'>Total Of Claims Paid</span>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span>AED {parseFloat(this.state.policyHealth.approvedTotal).toFixed(2)}</span>
                                </Col>
                            </Row>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card title="Pet Owner Details" className='full-width p-2'>
                                <Title level={5} className="text-green font-600 pt-1 m-0">Personal Details</Title>
                                <hr/>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>First Name</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.firstName}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Last Name</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.lastName}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Email</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.email}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Phone No</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{fixPhoneNumber(this.state.policy.phoneNo)}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Emirates Id</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.emiratesId}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Nationality</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.nationality}</span>
                                    </Col>
                                </Row>
                                <Title level={5} className="text-green font-600 pt-1 mt-2">Address</Title>
                                <hr/>
                                
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Apartment Number</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.addressApartment}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Street</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.addressStreet}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>City</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.addressCity}</span>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span className='text-green'>Country</span>
                                    </Col>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                        <span>{this.state.policy.addressCountry}</span>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </div>
                { 
                    this.state.policy.status == PolicyStatus.submitted &&
                    <div className='m-2'>
                        <Row gutter={15}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} align="end">
                                <Form
                                    name="basic"
                                    onFinish={this.savePolicyDocSentDate}
                                    // onFinishFailed={this.onPetFormFailed}
                                    size={"large"}
                                    ref={this.policyDocFormRef}
                                >
                                    <Form.Item
                                        className='formiteminline'
                                        name="documentSentDate"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select submitted Date*!',
                                            },
                                        ]}
                                    >
                                        <DatePicker className="mx-2"  placeholder="Please select submitted date!" format="YYYY/MMM/DD" />
                                    </Form.Item>
                                    <Form.Item className='formiteminline'>
                                        <Button className='btn-blue mx-2' type="primary" htmlType="submit">Policy Document Submitted</Button>
                                    </Form.Item>
                                </Form>
                                
                            </Col>
                        </Row>
                    </div>
                }
                {
                    this.state.policy.status == PolicyStatus.policy_doc_sent &&
                    <div className='m-2'>
                        <Row gutter={15}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} align="end">
                                <Form
                                    name="basic"
                                    onFinish={this.savePetTagSentDate}
                                    // onFinishFailed={this.onPetFormFailed}
                                    size={"large"}
                                    ref={this.petTagFormRef}
                                >
                                    <Form.Item
                                        className='formiteminline'
                                        name="documentSentDate"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select tag sent Date*!',
                                            },
                                        ]}
                                    >
                                        <DatePicker className="mx-2"  placeholder="Please select tag sent date!" format="YYYY/MMM/DD" />
                                    </Form.Item>
                                    <Form.Item className='formiteminline'>
                                        <Button className='btn-blue mx-2' type="primary" htmlType="submit">Pet Tag Sent</Button>
                                    </Form.Item>
                                </Form>
                                
                            </Col>
                        </Row>
                    </div>
                }
            </Layout>
        );
    }
}

export default AdminPolicyDetails;